import { render, staticRenderFns } from "./LayoutStructureFC.vue?vue&type=template&id=4db22aae&scoped=true"
import script from "./LayoutStructureFC.vue?vue&type=script&lang=js"
export * from "./LayoutStructureFC.vue?vue&type=script&lang=js"
import style0 from "./LayoutStructureFC.vue?vue&type=style&index=0&id=4db22aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db22aae",
  null
  
)

export default component.exports